import { render, staticRenderFns } from "./SearchCompanySupplier.vue?vue&type=template&id=5212aa24&"
import script from "./SearchCompanySupplier.vue?vue&type=script&lang=js&"
export * from "./SearchCompanySupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports